import { type ILevelItem, LevelState } from './types';

export const getCurrentLevelIndex = (levels: ILevelItem[]) => {
  if (levels.length === 0) return 0;

  const activeIndex = levels.findIndex(
    (level) => level.state === LevelState.Active
  );
  if (activeIndex !== -1) return activeIndex;

  // Furthest level actually reached, whatever happened to it afterwards
  // (done/claimed/canceled) - a later 100% level always outranks an earlier
  // one still waiting on a claim.
  const lastReachedIndex = levels.findLastIndex(
    (level) => level.percent === 100
  );
  if (lastReachedIndex !== -1) return lastReachedIndex;

  const lockedIndex = levels.findIndex(
    (level) => level.state === LevelState.Locked
  );
  if (lockedIndex !== -1) return lockedIndex;

  return levels.length - 1;
};
